import React from "react";
import PropTypes from "prop-types";

// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
import Add from "@material-ui/icons/Add";

import { withStyles, AppBar, Toolbar, IconButton, Hidden, Button } from "material-ui";

import { Button as ButtonComponent } from "components";
import cx from "classnames";
import DappsStore from '../../stores/DappsStore';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';

import headerStyle from "assets/jss/material-dashboard-react/headerStyle.jsx";

import HeaderLinks from "./HeaderLinks";

const Brand = createReactClass({
    mixins: [
        Reflux.connect(DappsStore, "data")
    ],
    render() {
        if (DappsStore.data.searchQuery && this.props.name !== 'Dapp') {
            return "Search for '" + DappsStore.data.searchQuery + "'";
        } else {
            return this.props.name;
        }
    }
});


function Header({...props}) {
    function makeBrand() {
        var name = 'Dapp';
        props.routes.map((prop, key) => {
            // console.log(props.location.pathname);
            // if (prop.navbarHide) return null;
            if (prop.path === props.location.pathname) {
                name = prop.navbarName;
            }
            return null;
        });
        // return DappsStore.data.searchQuery;
        return name;
    }
    const {classes, color} = props;
    const appBarClasses = cx({
        [" " + classes[color]]: color
    });
    return (
        <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          { /* Here we create navbar brand, based on route name */ }
          <ButtonComponent color="success" onClick={ props.addDapp } size="sm">
            { /*<Brand name="Add dapp" /> */}
            <Add/> 
            Add Dapp
          </ButtonComponent>
          <Button className={classes.title}>
            <Brand name={ makeBrand() } />
          </Button>
        </div>
        <Hidden smDown implementation="css">
          <HeaderLinks />
        </Hidden>
        <Hidden mdUp>
          <IconButton
        className={classes.appResponsive}
        color="inherit"
        aria-label="open drawer"
        onClick={props.handleDrawerToggle}
        >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
    );
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"])
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx